import React from 'react';

import svg from './assets/icons-24-warning.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

/** @deprecated Use the Icon component from the design-system-core-components package. */
export const IconWarning = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-warning" />
);
